module.exports = __webpack_public_path__ + "static/media/pedreiro.84594b1f.svg";